export const showStatus = function (type, message) {
  const img = type === 'success' ? 'tick' : 'cross';
  const statusBar = document.querySelector('.statusbar');

  const imgToReplace = statusBar.querySelector('img');
  const text = statusBar.querySelector('h4');

  text.innerText = message;
  imgToReplace.src = `/img/icons/${img}.png`;
  statusBar.style.display = 'flex';
  const tl = gsap.timeline({
    paused: true,
    onReverseComplete: () => {
      statusBar.style.display = 'none';
    },
  });
  tl.to('.statusbar', {
    top: '10%',
    opacity: 1,
    duration: 0.5,
    delay: 0.2,
  });
  tl.play();
  setTimeout(() => {
    tl.reverse();
  }, 5000);
};

export const signUp = async function () {
  try {
    const name = document.querySelector('#name').value;
    const email = document.querySelector('#email').value;
    const phone = document.querySelector('#phone').value;
    const password = document.querySelector('#password').value;
    const passwordConfirm = document.querySelector('#confirmPassword').value;

    if (!name || !email || !phone || !password || !passwordConfirm) {
      showStatus('fail', 'Missing Credentials');
      return;
    }
    const dataObj = {
      name: name,
      email: email,
      phoneNo: phone,
      password: password,
      passwordConfirm: passwordConfirm,
    };
    const res = await axios({
      method: 'POST',
      url: '/api/v1/users/signup',
      data: dataObj,
    });

    if (res.data.status === 'success') {
      showStatus('success', 'Signed In Successfully!');
      window.setTimeout(() => location.assign('/'), 1500);
    }
  } catch (error) {
    const errorMsg = error.response.data.message
      .replace('Invalid Input data', '')
      .trim();
    if (errorMsg.includes('8 characters'))
      showStatus('fail', 'Password must contain 8 letters');
    else showStatus('fail', errorMsg.split('.')[0]);
  }
};

export const login = async function () {
  try {
    const email = document.querySelector('#email').value;
    const password = document.querySelector('#password').value;

    if (!email || !password) {
      showStatus('fail', 'Login Credentials Missing');
      return;
    }

    const res = await axios({
      method: 'POST',
      url: '/api/v1/users/login',
      data: {
        email,
        password,
      },
    });
    if (res.data.status === 'success') {
      showStatus('success', 'Logged In Successfully!');
      window.setTimeout(() => location.assign('/'), 1500);
    }
  } catch (error) {
    const errorMsg = error.response.data.message;
    showStatus('fail', errorMsg);
  }
};

export const forgotPassword = async function () {
  try {
    const email = document.querySelector('#email').value;

    if (!email) {
      return showStatus('fail', 'Registered Email Missing');
    }
    const res = await axios({
      method: 'POST',
      url: '/api/v1/users/forgot-password',
      data: {
        email,
      },
    });
    if (res.data.status === 'success')
      showStatus('success', 'Password reset link sent');
  } catch (error) {
    const errorMsg = error.response.data.message;
    showStatus('fail', errorMsg);
  }
};

export const resetPassword = async function () {
  try {
    const password = document.querySelector('#password').value;
    const passwordConfirm = document.querySelector('#passwordConfirm').value;
    const resetToken = window.location.pathname.split('/').pop();
    const res = await axios({
      method: 'POST',
      url: `/api/v1/users/reset-password/${resetToken}`,
      data: {
        password,
        passwordConfirm,
      },
    });
    if (res.data.status === 'success') {
      showStatus('success', 'Password Changed Successfully');
      window.setTimeout(() => location.assign('/'), 1500);
    }
  } catch (error) {
    let errorMsgs = error.response.data.message.split('.');
    const errorMsg = errorMsgs.map((err) => {
      err = err.replace('Invalid Input data', '').trim();

      console.log(err);
      if (err.includes('8 characters')) return 'Create Stronger Password';
      else return err;
    });
    showStatus('fail', errorMsg[0]);
  }
};

export const createReview = async function (productId) {
  try {
    const review = document.querySelector('#user-review').value;
    const rating = document.querySelector('#user-rating').value;
    const res = await axios({
      method: 'POST',
      url: `/api/v1/products/${productId}/reviews`,
      data: {
        review,
        rating,
      },
    });
    if (res.data.status === 'success') {
      showStatus('success', 'Review posted!');
      window.setTimeout(() => location.reload(), 1500);
    }
  } catch (error) {
    const statCode = Number(error.status);
    if (statCode === 401) showStatus('fail', 'Please login first');
    else showStatus('fail', 'Invalid Review');
  }
};

export const deleteReview = async function (productId, reviewId) {
  try {
    const res = await axios({
      method: 'DELETE',
      url: `/api/v1/products/${productId}/reviews/${reviewId}`,
    });
    if (res.data.status === 'success') {
      showStatus('success', 'Review deleted!');
      window.setTimeout(() => location.reload(), 1500);
    }
  } catch (error) {
    const errorMsg = error.response.data.message;
    showStatus('fail', 'Failed to delete review');
  }
};

export const updateDetails = async function () {
  try {
    const email = document.querySelector('#email').value;
    const phoneNo = document.querySelector('#phone').value;
    const res = await axios({
      url: '/api/v1/users/update-details',
      method: 'POST',
      data: {
        email,
        phoneNo,
      },
    });
    if (res.data.status === 'success') {
      showStatus('success', 'Details Updated successfully');
      window.setTimeout(() => location.reload(), 1500);
    }
  } catch (error) {
    const errorMsg = error.response.data.message;
    showStatus('fail', 'Failed to update Details');
    window.setTimeout(() => location.reload(), 1500);
  }
};

export const logoutUser = async function () {
  try {
    const res = await axios({
      url: '/api/v1/users/logout',
      method: 'GET',
    });
    if (res.data.status === 'success') {
      showStatus('success', 'Logged out successfully');
      window.setTimeout(() => location.assign('/'), 1500);
    }
  } catch (error) {
    const errorMsg = error.response.data.message;
    showStatus('fail', 'Logout Failed');
  }
};
